import { render, staticRenderFns } from "./RiderHistory.vue?vue&type=template&id=2e241f68&scoped=true"
import script from "./RiderHistory.vue?vue&type=script&lang=js"
export * from "./RiderHistory.vue?vue&type=script&lang=js"
import style0 from "./RiderHistory.vue?vue&type=style&index=0&id=2e241f68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e241f68",
  null
  
)

export default component.exports